import React from "react";
import "./ThemeToggle.css";

function ThemeToggle({ isDarkMode, onToggle }) {
  return (
    <label 
      className="theme-switch"
      title={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
    >
      {/* The checkbox is hidden; we style the slider instead */}
      <input
        type="checkbox"
        checked={isDarkMode}
        onChange={onToggle}
      />
      <span className="slider"></span>
    </label>
  );
}

export default ThemeToggle;
